const groupedBarColors = [
  '#00A3BF', '#FFAB00', '#79F2C0', '#4C9AFF', '#FFA07A',
  '#C5E384', '#FFBCBC', '#A8D5BA', '#FFC400', '#FF5630',
  '#0052CC', '#36B37E', '#6554C0', '#00B8D9', '#D291BC',
  '#B39CD0', '#F7A072', '#B5EAD7', '#6A67CE', '#A2D5F2'
];

const PRGroupedBarChart = (rawData = []) => {
  const data = rawData.map(item => {
    const firstName = item?.profile?.firstName || '';
    const lastName = item?.profile?.lastName || '';
    return {
      name: `${firstName} ${lastName}`.trim(),
      prCount: item.prCount ?? 0
    };
  });

  if (data.length === 0) return {};

  const useDataZoom = data.length > 10;

  const names = data.map(item => item.name);
  const xAxisLabels = names.map(name => (name || '').slice(0, 2).toUpperCase());

  const allKeys = Object.keys(data[0]).filter(k => k !== 'name');

  const series = allKeys.map((key, i) => ({
    name: key.charAt(0).toUpperCase() + key.slice(1),
    type: 'bar',
    itemStyle: {
      color: groupedBarColors[i % groupedBarColors.length],
      borderRadius: [4, 4, 0, 0]
    },
    label: {
      show: true,
      position: 'top',
      formatter: params => params.value === 0 ? '0' : ''
    },
    data: data.map(d => d[key] ?? 0)
  }));

  return {
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      formatter: params => {
        const index = params[0].dataIndex;
        const fullName = names[index];
        const lines = params.map(p => `${p.marker} ${p.seriesName}: ${p.value}`);
        return [`<b>${fullName}</b>`, ...lines].join('<br/>');
      }
    },
    legend: { show: false },
    grid: {
      left: 0,
      right: 0,
      bottom: useDataZoom ? 35 : 35,
      top: 20,
      containLabel: true
    },
    dataZoom: useDataZoom
      ? [
        { type: 'inside', xAxisIndex: 0, start: 0, end: 40 },
        { type: 'slider', show: false, xAxisIndex: 0, height: 15, bottom: 40 }
      ]
      : [],
    xAxis: {
      type: 'category',
      data: xAxisLabels,
      axisLabel: {
        rotate: 0
      }
    },
    yAxis: {
      type: 'value',
      name: 'Count'
    },
    series
  };
};

export default PRGroupedBarChart;
